import useDebounce from 'shared/composables/debounce';
import { intersection } from 'shared/lib/array/array';
import { ref, watch } from 'vue';
import { subscriptionAction } from 'shared/constants.json';

/**
 * @param subscriptionSvc
 * @param {Repo} repo
 * @param options
 */
export default function useDataSync(subscriptionSvc, repo, options = { delay: 0, ignoreNonExistingData: false }) {
  const toQuery = ref([]);
  const requestIDs = ref([]);
  const subscribe = () => {
    subscriptionSvc.subscribe({
      model: repo.model,
      syncFn: ({ requestId, action, ids }) => {
        switch (action) {
          case subscriptionAction.update: {
            requestIDs.value.push(requestId);
            if (options.ignoreNonExistingData) {
              const filteredIds = intersection(ids, repo.ids.value.map((id) => parseInt(id, 10)));
              toQuery.value.push(...filteredIds);
              return;
            }
            toQuery.value.push(...ids);
            break;
          }
          case subscriptionAction.create:
            requestIDs.value.push(requestId);
            toQuery.value.push(...ids);
            break;
          case subscriptionAction.delete: {
            const filteredIds = intersection(ids, repo.ids.value.map((id) => parseInt(id, 10)));
            repo.deleteMultiple(filteredIds, { commitToRemote: false });
            break;
          }
          default:
            break;
        }
      },
    });
  };

  const { debounce } = useDebounce();

  watch(toQuery, (val) => {
    if (val.length === 0) {
      return;
    }

    const query = () => {
      const querying = [...toQuery.value];
      const syncFrom = [...requestIDs.value];
      repo.selectMultiple(querying, { commitToRemote: true, headerOpts: { baggage: `lagoon.model=${repo.model},lagoon.syncFrom=[${syncFrom.join('|')}]` } }).then((data) => {
        for (let i = 0; i < querying.length; i++) {
          if (!data.map(({ uid }) => uid).includes(querying[i])) {
            repo.deleteSingle(querying[i], { commitToRemote: false });
          }
        }
      });
      toQuery.value = [];
      requestIDs.value = [];
    };
    debounce(query, options.delay);
  }, { deep: true });

  return { subscribe };
}
